import {
  ASPECT_RATIO_OTHER,
  isGoogleAspectRatioSource,
} from "@nexus/contracts";

const ASPECT_RATIO_LABELS: Record<string, { suffix: string; fallback: string }> = {
  [ASPECT_RATIO_OTHER]: { suffix: "aspectRatioOther", fallback: "Other" },
};

/** Translates a My Brand aspect-ratio token. Ratio strings pass through. */
export function aspectRatioLabel(
  t: (key: string, defaultValue: string) => string,
  namespace: "overview" | "drilldown",
  value: string,
): string {
  const entry = ASPECT_RATIO_LABELS[value];
  if (!entry) return value;
  return t(`${namespace}.filters.${entry.suffix}`, entry.fallback);
}

/**
 * Aspect-ratio data exists on Demand Gen, Pmax, Video, and Display rows.
 * A specific selection counts when one of those is chosen. `null` is All, which
 * counts only when the tenant's available platforms include one.
 */
export function selectionIncludesGoogle(
  selectedPlatforms: readonly string[] | null,
  availablePlatforms: readonly string[] = [],
): boolean {
  const effective = selectedPlatforms === null ? availablePlatforms : selectedPlatforms;
  return effective.some((platform) => isGoogleAspectRatioSource(platform));
}
